import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectPreferences, selectView } from '../../Redux/selectors/selectors'
import { useCommonTheme } from '../../hooks/useCurrentTheme'
import {
	setMoveCellRangeMode,
	setMoveCellStrategyMode,
	setSelectedHandsOnePlayer,
	setSelectedHandsTwoPlayers,
} from '../../Redux/_actions/viewer'
import { getMatrixCellsObjects } from '../getMatrixCellsData'
import MultiMatrix from './MultiMatrix'
import styles from '../Viewer.module.scss'
import { constants } from '../viewModeConstants'

const getTreshold = (state) => state.preferences.dataNew.common.matrix.threshold

const MultiMatrixWrapper = ({
	isStrategy,
	field,
	structure,
	weight,
	isTrainer = false,
	handIndex = null,
	isNormalize = false,
	isSmallTrainerMatrix = false,
	isSettings = false,
	mockFilters = null,
	eqrMax = 0,
}) => {
	const {
		strategyFilters,
		rangeFilters,
		moveModeStrategy,
		selected_hands_strategy,
		selected_hands_range,
		viewMode,
		viewModeOnePlayer,
		onePlayerOpacityFilters,
		twoPlayersOpacityFilters,
		isMoveOpacityFiltersMode,
		activeTwoPlayersFiltersTab,
		lineSPFData,
		moveModeRange,
		viewModeTwoPlayers,
	} = useSelector(selectView)
	const equityLine = useSelector((state) => state.preferences.dataNew.common.matrix.equityLine)
	const { isDrawReverseActions } = useSelector((state) => state.preferences.dataNew.common)
	const {
		viewer: { mainMatrixValue },
	} = useSelector(selectPreferences)

	const threshold = useSelector(getTreshold)
	const dispatch = useDispatch()
	const { matrix } = useCommonTheme()
	const { indent } = matrix

	const filters = isSettings ? mockFilters : strategyFilters

	const indentStyle = indent ? styles.largeBorderSpacing : styles.smallBorderSpacing
	const moveMode = viewMode === constants.ONE_PLAYER ? moveModeStrategy : moveModeRange

	let selectedArr = viewMode === constants.ONE_PLAYER ? selected_hands_strategy.slice() : selected_hands_range.slice()

	const selectedCellsFunc = useCallback(
		(arr) =>
			viewMode === constants.ONE_PLAYER || isTrainer
				? dispatch(setSelectedHandsOnePlayer(arr))
				: dispatch(setSelectedHandsTwoPlayers(arr)),
		[viewMode, isTrainer]
	)

	const setSelectedCellMode = useCallback(
		(val) =>
			viewMode === constants.ONE_PLAYER ? dispatch(setMoveCellStrategyMode(val)) : dispatch(setMoveCellRangeMode(val)),
		[viewMode]
	)

	useEffect(() => {
		if (selectedArr.length === 0) {
			setSelectedCellMode(false)
		}
	}, [selectedArr.length])

	/* getting cells objects*/
	const cellsData = useMemo(() => {
		return getMatrixCellsObjects({
			isStrategy,
			structure,
			filter: viewMode === constants.ONE_PLAYER ? filters : rangeFilters,
			filterOpacity: viewMode === constants.ONE_PLAYER ? onePlayerOpacityFilters : twoPlayersOpacityFilters,
			field: isStrategy && mainMatrixValue ? mainMatrixValue : field,
			weight,
			isMoveOpacityFiltersMode,
			isOnePlayer: viewMode === constants.ONE_PLAYER,
			isNormalize,
			selectedArr: selected_hands_strategy,
			onSelectedHandChanged: selectedCellsFunc,
			heroHandIndex: handIndex,
			activeTwoPlayersFiltersTab,
			lineSPFData,
			moveModeStrategy,
			threshold,
			isDrawReverseActions,
		})
	}, [
		isStrategy,
		structure,
		field,
		isNormalize,
		threshold,
		filters,
		rangeFilters,
		onePlayerOpacityFilters,
		twoPlayersOpacityFilters,
		isDrawReverseActions,
		mainMatrixValue,
	])

	return (
		<MultiMatrix
			isSmallTrainerMatrix={isSmallTrainerMatrix}
			weight={weight}
			viewMode={viewMode}
			moveMode={moveMode}
			cellsData={cellsData}
			isTrainer={isTrainer}
			equityLine={equityLine}
			indentStyle={indentStyle}
			isNormalize={isNormalize}
			selectedCell={selectedArr}
			viewModeOnePlayer={viewModeOnePlayer}
			selectedCellsFunc={selectedCellsFunc}
			viewModeTwoPlayers={viewModeTwoPlayers}
			setSelectedCellMode={setSelectedCellMode}
			strategyFilters={filters}
			isSettings={isSettings}
			eqrMax={eqrMax}
		/>
	)
}

export default MultiMatrixWrapper
